import { clsx, ClassValue } from 'clsx';

import { Icons } from '../icons';

import { UniversalImage } from './UniversalImage';

type AvatarProps = {
  src?: string;
  alt?: string;
  className?: ClassValue;
  dataTestId?: string;
  priority?: boolean;
  size: 24 | 60 | 70 | 80 | 100 | 120 | 160 | 280;
  onClick?: () => void;
  sizes?: string;
};

/**
 * Использование в проектах: immigrant-invest, golden-visa
 *
 * Стили: tiny-components/src/lib/styles/avatar.css
 */
export function Avatar({
  src,
  alt = '',
  className,
  dataTestId = 'avatar',
  priority,
  size = 100,
  onClick,
  sizes,
}: AvatarProps) {
  if (!src) {
    return (
      <div
        data-testid='avatar-placeholder'
        style={{
          width: size,
        }}
        className={clsx(
          'avatar bg-grey rounded-full flex justify-center items-center border aspect-square border-border shrink-0 h-auto',
          className
        )}
      >
        <Icons
          icon='person'
          sizeClassName='w-9/12'
          isInteractive
          className='bg-blue-500'
        />
      </div>
    );
  }

  return (
    <UniversalImage
      onClick={onClick}
      dataTestId={dataTestId}
      className={clsx(
        'avatar skeleton rounded-full object-cover overflow-hidden aspect-square shrink-0 h-fit',
        className
      )}
      pattern='dimensions'
      width={size}
      height={size}
      src={src}
      priority={priority}
      alt={alt}
      sizes={sizes}
    />
  );
}
